// test73
(73 && 0);
